import request from '@/utils/request'

const sessionApi = {
  sessions: '/api/sessions',
  sessionSqls: '/api/sessions/sqls',
  allSessionSqls: '/api/sessions/sqls/all',
  rerunSessionSqls: '/api/sessions/rerun',
  resetSession: '/api/sessions/reset',
  dbSchema: '/api/yasdbs/users/current',
}

export function sessionsApi(params) {
  return request({
    url: sessionApi.sessions,
    method: 'get',
    params: params
  })
}

export function sessionSqlsApi(params) {
  return request({
    url: sessionApi.sessionSqls,
    method: 'get',
    params: params
  })
}

export function allSessionSqlsApi(params) {
  return request({
    url: sessionApi.allSessionSqls,
    method: 'get',
    params: params
  })
}

export function delSessionSqlsApi(params) {
  return request({
    url: sessionApi.sessions,
    method: 'delete',
    data: params
  })
}

export function rerunSessionSqlsApi(params) {
  return request({
    url: sessionApi.rerunSessionSqls,
    method: 'post',
    data: params
  })
}

export function resetSession(params) {
  return request({
    url: sessionApi.resetSession,
    method: 'post',
    data: params
  })
}

export function currentSchema(params) {
  return request({
    url: sessionApi.dbSchema,
    method: 'get'
  })
}


export function swapSchema(params) {
  return request({
    url: sessionApi.dbSchema,
    method: 'post',
    data: params
  })
}

